import React from "react";
import { Barras, COLORES, Columnas, Kpis, Pagina, Tabla, Tarjeta, fmtM, fmtP, useDatos, usePeriodo } from "./comun";

function ReporteCartera() {
  const periodo = usePeriodo();
  const { datos: d, error } = useDatos(`/cartera/${periodo.inicio}/${periodo.fin}`);
  const k = d?.kpis;
  return (
    <Pagina titulo="Cobranza y pagos" subtitulo="Lo que nos deben contra lo que debemos" periodo={periodo} error={error} cargando={!d}>
      {d && <>
        <Kpis items={[
          { t: "Por cobrar", v: fmtM(k.porCobrar) }, { t: "Vencido", v: fmtM(k.vencido), d: `${fmtP(k.pctVencido)} de la cartera`, tono: k.pctVencido > 20 ? "baja" : "" },
          { t: "Cobrado en el periodo", v: fmtM(k.cobrado) }, { t: "Por pagar", v: fmtM(k.porPagar) }, { t: "Posicion neta", v: fmtM(k.neto), tono: k.neto < 0 ? "baja" : "sube" },
        ]} />
        <div className="rp-grid">
          <Tarjeta titulo="Cobrado y pagado por mes" ancho>
            <Columnas datos={d.meses} series={[{ key: "cobrado", label: "Cobrado a clientes", color: COLORES[0] }, { key: "pagado", label: "Pagado a proveedores", color: COLORES[2] }]} />
          </Tarjeta>
          <Tarjeta titulo="Antiguedad de saldos"><Barras datos={d.antiguedad} valor="valor" /></Tarjeta>
          <Tarjeta titulo="Por pagar a proveedores"><Barras datos={d.porProveedor} valor="saldo" color={COLORES[2]} /></Tarjeta>
          <Tarjeta titulo="Compras por pagar" nota="Primero las mas antiguas" ancho>
            <Tabla filas={d.comprasPorPagar} columnas={[{ t: "Compra", k: "compra" }, { t: "Fecha", k: "fecha" }, { t: "Proveedor", k: "proveedor" }, { t: "Total", k: "total", f: fmtM, n: 1 }, { t: "Saldo", k: "saldo", f: fmtM, n: 1 }, { t: "Dias", k: "dias", n: 1 }]} />
          </Tarjeta>
          <Tarjeta titulo="Clientes con mayor saldo" ancho>
            <Tabla filas={d.deudores} columnas={[{ t: "Cliente", k: "nombre" }, { t: "Saldo", k: "saldo", f: fmtM, n: 1 }, { t: "Vencido", k: "vencidoImp", f: fmtM, n: 1 }]} />
          </Tarjeta>
        </div>
      </>}
    </Pagina>
  );
}
export default ReporteCartera;
